export default [
  {
    path: 'companies',
    children: [
      {
        name: 'companies',
        path: '',
        component: () => import('./CompaniesList.vue'),
        meta: {
          title: 'Companies'
        }
      },
      {
        name: 'create-company',
        path: 'create',
        component: () => import('./CompanyForm.vue'),
        meta: {
          title: 'New Company'
        },
        props: {
          type: 'New'
        }
      },
      {
        name: 'edit-company',
        path: ':id/edit',
        component: () => import('./CompanyForm.vue'),
        meta: {
          title: 'Edit Company'
        },
        props: (route) => ({
          type: 'Edit',
          id: route.params.id
        })
      },
      {
        name: 'view-company',
        path: ':id/view',
        component: () => import('./CompanyView.vue'),
        meta: {
          title: 'View Company'
        },
        props: (route) => ({
          id: route.params.id
        })
      }
    ]
  },
]
